import { render, staticRenderFns } from "./stocks.vue?vue&type=template&id=885247d2&scoped=true&lang=pug"
import script from "./stocks.vue?vue&type=script&lang=ts"
export * from "./stocks.vue?vue&type=script&lang=ts"
import style0 from "./stocks.vue?vue&type=style&index=0&id=885247d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885247d2",
  null
  
)

export default component.exports